<template>
  <div>
    <b-button
      variant="primary"
      :disabled="isSigningUp || !configId"
      @click="launchWhatsAppSignup"
      >Login com Facebook</b-button
    >
    <b-alert v-if="!configId" show variant="warning" class="mt-3">
      O login do WhatsApp precisa ser configurado para o Embedded Signup v4.
    </b-alert>
    <b-alert v-if="error" show variant="danger" class="mt-3">
      {{ error }}
    </b-alert>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  props: {
    block: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      configId: process.env.VUE_APP_FACEBOOK_LOGIN_CONFIG_ID,
      isSigningUp: false,
      error: null
    };
  },

  beforeDestroy() {
    if (this.cleanupSignup) this.cleanupSignup();
  },

  methods: {
    launchWhatsAppSignup() {
      if (this.isSigningUp || !this.configId) return;
      this.error = null;

      if (!window.FB) {
        this.error = "O Facebook ainda não carregou. Tente novamente.";
        return;
      }

      this.isSigningUp = true;
      let resolveSession;
      let sessionTimeout;
      let active = true;
      const sessionInfoPromise = new Promise((resolve) => {
        resolveSession = resolve;
      });
      const sessionInfoListener = (event) => {
        if (
          !["https://www.facebook.com", "https://web.facebook.com"].includes(
            event.origin
          )
        )
          return;

        let message;
        try {
          message =
            typeof event.data === "string"
              ? JSON.parse(event.data)
              : event.data;
        } catch {
          return;
        }
        if (!message || message.type !== "WA_EMBEDDED_SIGNUP") return;

        if (
          [
            "FINISH",
            "FINISH_ONLY_WABA",
            "FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING"
          ].includes(message.event)
        ) {
          resolveSession(message.data || null);
        } else if (["CANCEL", "ERROR"].includes(message.event)) {
          resolveSession(null);
        }
      };
      const cleanup = () => {
        active = false;
        window.removeEventListener("message", sessionInfoListener);
        clearTimeout(sessionTimeout);
        resolveSession(null);
        this.isSigningUp = false;
        this.cleanupSignup = null;
      };
      this.cleanupSignup = cleanup;
      window.addEventListener("message", sessionInfoListener);

      try {
        window.FB.login(
          async (response) => {
            try {
              if (
                !active ||
                !response.authResponse ||
                !response.authResponse.code
              )
                return;
              sessionTimeout = setTimeout(() => resolveSession(null), 10000);
              const sessionInfo = await sessionInfoPromise;
              if (!active) return;
              if (!sessionInfo || !sessionInfo.waba_id) {
                this.error =
                  "Não foi possível obter os dados da conta do WhatsApp. Tente novamente.";
                return;
              }

              await ApiService.post("whatsapp/access_token", {
                code: response.authResponse.code,
                waba_id: sessionInfo.waba_id
              });
              if (active) this.$emit("login-success", sessionInfo);
            } catch {
              if (active)
                this.error =
                  "Não foi possível conectar a conta do WhatsApp. Tente novamente.";
            } finally {
              cleanup();
            }
          },
          {
            // Create a v4 configuration in Facebook Login for Business.
            config_id: this.configId,
            // Allow another signup while the user is already logged in.
            auth_type: "rerequest",
            response_type: "code",
            override_default_response_type: true,
            extras: {
              setup: {},
              featureType: "whatsapp_business_app_onboarding"
            }
          }
        );
      } catch {
        this.error =
          "Não foi possível abrir o login do Facebook. Tente novamente.";
        cleanup();
      }
    }
  }
};
</script>
